var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "column-layout clearfix",
      staticStyle: { height: "100%", overflow: "hidden" }
    },
    [
      _c("div", { staticClass: "left-column fl" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "table-layout",
            staticStyle: { "overflow-y": "auto" },
            attrs: { id: "tree-menu" }
          },
          [
            _c("el-tree", {
              attrs: { props: _vm.props, load: _vm.loadNode, lazy: "" },
              on: { "node-click": _vm.handleNodeClick }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-column fl", staticStyle: { height: "100%" } },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("swb-query-sort-area", {
            ref: "query_model",
            attrs: { config: _vm.queryConfig, queryHandler: _vm.queryHandler }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "table-layout",
              staticStyle: {
                "overflow-y": "auto",
                height: "calc(100% - 150px)"
              }
            },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.outerStaffList,
                    border: "",
                    "tooltip-effect": "dark"
                  },
                  on: { select: _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", type: "selection", width: "55" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orgFullPathName",
                      label: "所属机构",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "no",
                      label: "用户编号",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "用户名称",
                      align: "left",
                      width: "120",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "namePy",
                      label: "名称拼音",
                      align: "left",
                      width: "120",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rankName",
                      label: "职衔",
                      align: "left",
                      width: "120",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "phoneNo",
                      label: "手机号",
                      align: "center",
                      width: "120",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "创建时间",
                      align: "center",
                      width: "140",
                      "show-overflow-tooltip": ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-container base" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c("ul", { staticClass: "head" }, [
          _c("li", { staticClass: "head-item current" }, [_vm._v("机构信息")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-container base" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c("ul", { staticClass: "head clearfix" }, [
          _c("li", { staticClass: "head-item current" }, [
            _c("a", { staticClass: "font14" }, [_vm._v("员工信息")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf6409c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf6409c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/oaAudit/MerchtAuditBpStaffList.vue
// module id = 2543
// module chunks = 0